import { CellContext } from "@tanstack/react-table"
import dayjs from "lib/dayjs"
import styled from "styled-components"

import { UITypes } from "types"

// Temporarily hidden — set to true to show the "Week N, YYYY" label again.
const SHOW_WEEK_LABEL = false

const WeekLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
`

const DateRange = styled.div<{ $standalone: boolean }>`
  font-size: ${({ $standalone }) => ($standalone ? "14px" : "12px")};
  font-weight: ${({ $standalone }) => ($standalone ? "500" : "400")};
  color: ${({ $standalone }) => ($standalone ? "#0f172a" : "#94a3b8")};
  margin-top: ${({ $standalone }) => ($standalone ? "0" : "2px")};
`

const getISOWeek = (dateStr: string): number => {
  const d = new Date(dateStr)
  const utc = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
  const dayNum = utc.getUTCDay() || 7
  utc.setUTCDate(utc.getUTCDate() + 4 - dayNum)
  const yearStart = new Date(Date.UTC(utc.getUTCFullYear(), 0, 1))
  return Math.ceil(((utc.getTime() - yearStart.getTime()) / 86400000 + 1) / 7)
}

interface ReportItem {
  start_date: string
  end_date: string
}

interface Props {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const ReportingPeriodCell = ({ cell }: Props) => {
  const item = cell.row.original.rowSettings?.item as ReportItem | undefined
  if (!item?.start_date) return null

  const weekNum = getISOWeek(item.start_date)
  const year = dayjs(item.start_date).year()
  const startFormatted = dayjs(item.start_date).format("MM.DD")
  const endFormatted = dayjs(item.end_date).format("MM.DD.YYYY")

  return (
    <div>
      {SHOW_WEEK_LABEL && (
        <WeekLabel>
          Week {weekNum}, {year}
        </WeekLabel>
      )}
      <DateRange $standalone={!SHOW_WEEK_LABEL}>
        {startFormatted} – {endFormatted}
      </DateRange>
    </div>
  )
}
